module.exports = __webpack_public_path__ + "ffa1f15132503b750c7b27cfb951cd16.jpg";